import React from "react";

export default function Table() {
  return (
    <div
      className="table-body"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "inherit",
        width: "100%",
        // backgroundColor: "red",
        margin: "-25% 5% 0 5%",
      }}
    >
      <div
        className="table-row"
        style={{
          display: "flex",
          justifyContent: "flex-start",
          borderBottom: "2px solid  rgb(179,178,179)",
        }}
      >
        <div
          className="table-column-icon"
          style={{ display: "flex", width: "20%", marginRight: "10%" }}
        >
          <h5
            style={{
              fontSize: "1.6rem",
              fontWeight: 900,
              color: "white",
              marginBottom: "18px",
            }}
          >
            Category
          </h5>
        </div>
        <div
          className="table-column-text"
          style={{ display: "flex", width: "70%" }}
        >
          <h5
            style={{
              fontSize: "1.6rem",
              fontWeight: 900,
              color: "white",
              marginBottom: "18px",
            }}
          >
            Country and Language
          </h5>
        </div>
      </div>
      <div
        className="table-row"
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "2px solid  rgb(179,178,179)",
          opacity: 0,
          animation: `0.5s ease 0.3s 1 normal forwards running fadeInUp`,
        }}
      >
        <div
          className="table-column-icon"
          style={{ display: "flex", width: "20%", marginRight: "10%" }}
        >
          <img
            style={{
              justifySelf: "center",
              alignSelf: "center",
              width: "100%",
              height: "auto",
            }}
            alt=""
            src="/application/webos/webos_tv_emulator/images/thinq-logo-2.svg"
          />
        </div>
        <div
          className="table-column-text"
          style={{ display: "flex", flexDirection: "column", width: "70%" }}
        >
          <h6
            style={{
              margin: "4% 0 0 0",
              fontSize: "1.6rem",
              fontWeight: 900,
              color: "rgb(199,8,72)",
            }}
          >
            144 countries
          </h6>
          <p
            style={{
              margin: "0",
              fontSize: "1.2rem",
              fontFamily: "LG_Smart_Regular",
              color: "rgb(206,207,208)",
            }}
          >
            Global expansion based on common language (8)
          </p>
          <h6
            style={{
              margin: "6% 0 0 0",
              fontSize: "1.6rem",
              fontWeight: 900,
              color: "rgb(199,8,72)",
            }}
          >
            20 languages
          </h6>
          <p
            style={{
              margin: "0",
              fontSize: "1.2rem",
              fontFamily: "LG_Smart_Regular",
              color: "rgb(206,207,208)",
              // wordWrap: "break-word",
            }}
          >
            English / Korean / Spanish / French / German / Italian / Portuguese
            / Russian / Polish / Turkish / Japanese / Arabic (Saudi / UAE) /
            Vietnamese / Thai / Swedish / Taiwanese / Indonesian / Danish /
            Dutch / Norwegian
          </p>
          <br />
        </div>
      </div>
      <div
        className="table-row"
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "2px solid rgb(179,178,179)",
          opacity: 0,
          animation: `0.5s ease 1s 1 normal forwards running fadeInUp`,
        }}
      >
        <div
          className="table-column-icon"
          style={{ display: "flex", width: "20%", marginRight: "10%" }}
        >
          <img
            style={{
              justifySelf: "center",
              alignSelf: "center",
              width: "100%",
              height: "auto",
            }}
            alt=""
            src="/application/webos/webos_tv_emulator/images/alexa-logo-2.svg"
          />
        </div>
        <div
          className="table-column-text"
          style={{ display: "flex", flexDirection: "column", width: "70%" }}
        >
          <h6
            style={{
              margin: "4% 0 0 0",
              fontSize: "1.6rem",
              fontWeight: 900,
              color: "rgb(199,8,72)",
            }}
          >
            36 countries
          </h6>
          <p
            style={{
              margin: "0",
              fontSize: "1.2rem",
              fontFamily: "LG_Smart_Regular",
              color: "rgb(206,207,208)",
            }}
          >
            Austria / Brazil / Canada / France / Germany / India / Ireland /
            Italy / Japan / Mexico / New Zealand / Spain / United Kingdom /
            United States / Netherlands / Colombia / Chile / Argentina / Costa
            Rica / Peru / Sweden / Poland / Belgium / Switzerland / Singapore /
            Turkey / Denmark / Norway / Malaysia / Indonesia / Philippines /
            Finland / Luxembourg / Portugal / Saudi Arabia / Egypt
          </p>
          <h6
            style={{
              margin: "6% 0 0 0",
              fontSize: "1.6rem",
              fontWeight: 900,
              color: "rgb(199,8,72)",
            }}
          >
            7 languages
          </h6>
          <p
            style={{
              margin: "0",
              fontSize: "1.2rem",
              fontFamily: "LG_Smart_Regular",
              color: "rgb(206,207,208)",
            }}
          >
            English / German / French / Japanese / Spanish / Italian /
            Portuguese
          </p>
          <br />
        </div>
      </div>
    </div>
  );
}
